import { AuthShell, ForgotPasswordForm } from "@nexys/user-management-web";
import { Link } from "react-router-dom";

export const ForgotPasswordPage = () => (
  <AuthShell brand="UM-RS Console">
    <ForgotPasswordForm
      signInSlot={
        <Link to="/sign-in" className="text-primary hover:underline">
          Back to sign in
        </Link>
      }
    />
  </AuthShell>
);
